import { render, staticRenderFns } from "./CoinAnatomySafari.vue?vue&type=template&id=5bb2050b&"
import script from "./CoinAnatomySafari.vue?vue&type=script&lang=ts&"
export * from "./CoinAnatomySafari.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports